import './MainPageFacade.scss'
import React from "react";
import {observer} from "mobx-react-lite";
import {useNavigate} from "react-router";
import {Box, Button, Chip, Grid, Typography} from "@mui/material";
import {ChevronLeft} from "@mui/icons-material";
import {CONTENT_PADDING} from "../drawer/DrawerConstants.ts";
import {LoadingBarComponent} from "../../loading-bar/LoadingBarComponent.tsx";

type ButtonSpec = {
    type: 'btn'
    link: string
    label: string
} | {
    type: 'component'
    node: React.ReactNode
}

type Props = {
    title: string | React.ReactNode;
    titlePostfix?: React.ReactNode;
    titleTag?: React.ReactNode | string;
    back?: string | false | ButtonSpec;
    backLabel?: string;
    backClass?: string;
    onBack?: () => void;
    next?: ButtonSpec;
    nextClass?: string;
    actionBarStart?: React.ReactNode;
    actionBarEnd?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
}
export const MainPageFacade: React.FC<Props> = observer((
  {
      title,
      titlePostfix,
      titleTag,
      back,
      backLabel,
      backClass,
      onBack,
      next,
      nextClass,
      actionBarStart,
      actionBarEnd,
      className,
      children,
  }) => {
  const navigate = useNavigate();

  const _titleTag = React.useMemo(() => {
    if (titleTag === undefined) return null;
    if (typeof titleTag === 'string') {
        if (titleTag === 'beta') {
            return <Chip label="BETA" variant="filled" color="primary" className="mx-4"/>
        }
        return <Typography variant="subtitle1" component="span" className="mx-4">{titleTag}</Typography>;
    }
    return titleTag;
  }, [titleTag]);

  return <>
      <LoadingBarComponent/>
      <main id="main-component-content" style={{
          padding: `${CONTENT_PADDING}px ${CONTENT_PADDING}px 0`
      }}>
          <div id="main-page-facade" className={className}>
              <Grid sx={{marginBottom: '16px'}} container component="header" id="main-page-facade-header"
                    alignItems="center">
                  {back !== undefined && <Grid className={backClass ?? 'text-center'}>
                      {(typeof back === 'string')
                          ? <Button
                sx={{mr: 2}}
                color="primary"
                variant="outlined"
                startIcon={<ChevronLeft/>}
                onClick={() => onBack ? onBack() : navigate('' + back)}>
                              {backLabel === undefined ? 'Back' : backLabel}
                          </Button>
                          : typeof back === 'object'
                              ? (back.type === 'component'
                                  ? back.node
                                  : <Button
                    color="primary"
                    variant="outlined"
                    startIcon={<ChevronLeft/>}
                    onClick={() => navigate('' + back.link)}>
                                      {back.label === undefined ? 'Next' : back.label}
                                  </Button>)
                              : null
                      }
                  </Grid>}
                  <Grid className="page-title">
                      {typeof title === 'string' ?
                          <Typography variant="h1" component="h1">{title}{titlePostfix}{_titleTag}</Typography>
                          : <>{title}{titlePostfix}{_titleTag}</>
                      }
                  </Grid>
                  {actionBarStart}
                  <Box sx={{flexGrow: 1}}/>
                  {actionBarEnd}
                  {next &&
            <Grid className={nextClass ?? 'text-center'}>
                {next?.type === 'btn' &&
                <Button
                  color="primary"
                  variant="contained"
                  // startIcon={<ArrowBack/>}
                  onClick={() => navigate('' + next.link)}>
                    {next.label === undefined ? 'Next' : next.label}
                </Button>
                }
                {next?.type === 'component' && next.node}
            </Grid>
                  }
              </Grid>
              {children}
          </div>
      </main>
  </>
});
